import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { computed, onMounted, reactive } from 'vue'
import type { PropType } from 'vue'
import { useRoute } from 'vue-router'
import type { ClueManage } from '@/typings/api/marketingManage'
import { fbuFollowRecordsList } from '@/api/gucangSales/followUpManage'
import { lbuFollowRecordsList } from '@/api/yuntuSales/followUpManage'
import { listByParamCodes } from '@/api/common'
import xss from 'xss'

const __default__ = { name: 'ContactsTable' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object as PropType<ClueManage>
  },
  appId: {
    type: String as PropType<'cos_zbu_fbu' | 'cos_zbu_lbu'>,
    default: 'cos_zbu_fbu'
  },
  followRefId: String
},
  setup(__props) {

const route = useRoute()
const props = __props
const paramCodeData = reactive<{
  follow_mode: []
  follow_purpose: []
}>({
  follow_mode: [], // 拜访方式
  follow_purpose: [] // 访客目的
})
const appIdEumn = {
  cos_zbu_fbu: 'cos_fbu',
  cos_zbu_lbu: 'cos_lbu'
}
const appIdPre = computed(() => {
  const eumn = {
    cos_zbu_fbu: 'fbu',
    cos_zbu_lbu: 'lbu'
  }
  return eumn[props.appId]
})

// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: appIdEumn[props.appId],
    paramCodes: [`${appIdPre.value}_follow_mode`, `${appIdPre.value}_follow_purpose`]
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.follow_mode = res.data[`${appIdPre.value}_follow_mode`]
      paramCodeData.follow_purpose = res.data[`${appIdPre.value}_follow_purpose`]
    }
  })
}
// 跟进记录
const fetch = async (params: object, callBack: (res: any) => void) => {
  try {
    if (!props.followRefId) {
      setTimeout(() => {
        callBack([])
      }, 500)
      return
    }
    let res: any = []
    if (appIdPre.value === 'fbu') {
      res = await fbuFollowRecordsList({
        ...params,
        followRefId: props.followRefId
      })
    } else if (appIdPre.value === 'lbu') {
      res = await lbuFollowRecordsList({
        ...params,
        followRefId: props.followRefId
      })
    }
    callBack(res)
  } catch (error) {
    console.log('error: ', error)
  }
}
const columns = computed(() => {
  const init = [
    { title: '跟进方式', dataIndex: 'mode', dicData: paramCodeData.follow_mode },
    { title: '跟进时间', dataIndex: 'startTime', width: 350 },
    {
      title: '具体详情',
      dataIndex: `${appIdPre.value}Process`,
      width: 350
    },
    { title: '创建人', dataIndex: 'createByName' },
    { title: '创建时间', dataIndex: 'createTime', width: 190 }
  ]
  if (appIdPre.value === 'fbu') {
    return [
      {
        title: '跟进目的',
        dataIndex: 'fbuPurpose',
        dicData: paramCodeData.follow_purpose
      },
      ...init
    ]
  } else {
    return init
  }
})
onMounted(() => {
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    onFetch: fetch,
    serial: "",
    columns: columns.value,
    ref: "table",
    tableId: `${_unref(route).path}_TabsClueCosFollowUp`
  }, {
    bodyCell: _withCtx(({ column, record, text }) => [
      (column.dataIndex === 'startTime')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text) + "~" + _toDisplayString(record.endTime), 1))
        : _createCommentVNode("", true),
      (column.dataIndex === 'fbuProcess')
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            innerHTML: _unref(xss)(record.process)
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (column.dataIndex === 'lbuProcess')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("p", null, "跟进目的：" + _toDisplayString(record.lbuPurpose), 1),
            _createElementVNode("p", null, "跟进过程：" + _toDisplayString(record.process), 1),
            _createElementVNode("p", null, "后续：" + _toDisplayString(record.result), 1),
            _createElementVNode("p", null, "当前遇到的问题：" + _toDisplayString(record.problem), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})